import "./TransportStatistic.scss";

import { Box } from "@mui/material";

import TotalVehiclesCard from "../../components/TotalVehiclesCard/TotalVehiclesCard";
import OperationVehiclesCard from "../../components/OprationVeihiclesCard/OperationVehiclesCard";
import BrokenVehiclesCard from "../../components/BrokenVehiclesCard/BrokenVehiclesCard";

import BranchTransportStatistic from "../../components/BranchTransportStatistic/BranchTransportStatistic";
import VehicleTypeStatistic from "../../components/VehiclesTypeStatistic/VehiclesTypeStatistic";
import UsageTypeStatistic from "../../components/UsageTypeStatistic/UsageTypeStatistic";
import ActionTypeStatistic from "../../components/ActionTypeStatistic/ActionTypeStatistic";
import OwnerStatistic from "../../components/OwnerStatistic/OwnerStatistic";
import UserStatistic from "../../components/UserStatistic/UserStatistic";
import InsuranceExpiredStatistic from "../../components/InsuranceExpiredStatistic/InsuranceExpiredStatistic";
import InspectionExpiredStatistic from "../../components/InspectionExpiredStatisic/InspectionExpiredStatistic";
import RentalPriceAvgStatistic from "../../components/RentalPriceAvgStatistic/RentalPriceAvgStatistic";

const TransportStatistic = () => {

    return (
        <Box className={"transport_statistic_page"}>
            <Box className={"transport_statistic_page_container"}>
                <Box className={"transport_statistic_page_container_cards"}>
                    <TotalVehiclesCard/>
                    <OperationVehiclesCard/>
                    <BrokenVehiclesCard/>
                </Box>
                <Box className={"transport_statistic_page_container_charts"}>
                    <BranchTransportStatistic/>
                    <VehicleTypeStatistic/>
                    <UsageTypeStatistic/>
                    <ActionTypeStatistic/>
                    <OwnerStatistic/>
                    <UserStatistic/>
                    <InsuranceExpiredStatistic/>
                    <InspectionExpiredStatistic/>
                </Box>
            </Box>
        </Box>
    )
}

export default TransportStatistic;